var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { staticClass: "my-2 align-center", attrs: { row: "", wrap: "" } },
    [
      _c("v-flex", { attrs: { xs4: "" } }, [
        _vm._v(_vm._s(_vm.splitByAllCapitalLetters(_vm.field.Field))),
      ]),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs8: "" } },
        [
          _c(
            "v-chip",
            { attrs: { label: "", small: "", icon: "pageview" } },
            [
              _c("v-icon", { staticClass: "mr-1" }, [
                _vm._v("insert_drive_file"),
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  attrs: {
                    to: {
                      name: "dataset",
                      params: { id: _vm.field.FieldValue },
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.field.FieldValue) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }